import { SET_NOTIFICATIONS } from 'actions/constants';
import { dispatch, getAuthorization, getStore } from 'controllers/controller';
import { getNotificationsService } from 'services/notifications/getNotifications';
import { updateAllNotificationAsSeen } from './updateAllNotificationAsSeen';

export const getNotifications = async (isLoadMore = false) => {
  const authorization = getAuthorization();
  const uid = getStore().user.details.userId;
  const notifications = getStore().user.notifications;
  const paginationParams = {
    page: isLoadMore ? notifications.page + 1 : 0,
    size: notifications.size,
  };

  const { data } = await getNotificationsService(
    authorization,
    uid,
    paginationParams
  );

  const newNotifications = data.response;

  const notificationsList = isLoadMore
    ? [...notifications.list, ...newNotifications.content]
    : newNotifications.content;

  dispatch({
    type: SET_NOTIFICATIONS,
    notifications: {
      list: notificationsList,
      count: newNotifications.notificationCount,
      page: newNotifications.currentPage,
      size: newNotifications.pageSize,
      hasMore: newNotifications.totalPage > newNotifications.currentPage + 1,
    },
  });
};

export const toggleNotificationBar = (showNotifications) => {
  const { count } = getStore().user.notifications;

  if (!showNotifications) {
    document.body.style.overflow = 'auto';
    getNotifications();
  } else {
    document.body.style.overflow = 'hidden';

    if (count) {
      updateAllNotificationAsSeen();
    }
  }

  dispatch({
    type: SET_NOTIFICATIONS,
    notifications: { showNotifications },
  });
};
